import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { UXPContext } from '@core/context/Context';
import { FontAwesomeIconWrapper } from '@icon/fontawesome/FontAwesomeIconWrapper';
/**
 * @export
 * Flash alert component that displays a loading message with spinner overlay.
 * Automatically shown when context.isLoading is true.
 */
const LoadingFlashAlert = (props) => {
    const context = React.useContext(UXPContext);
    if (!context.isLoading)
        return null;
    return _jsxs("div", { className: "uxpcore_loading-flash-alert", children: [_jsx("div", { className: "uxpcore_loading-flash-alert__message", children: context.loadingMessage }), _jsx("div", { className: "uxpcore_loading-flash-alert__icon", children: _jsx(FontAwesomeIconWrapper, { icon: ['fas', 'spinner'], spin: true }) })] });
};
export default LoadingFlashAlert;
